module.exports = __webpack_public_path__ + "static/clearface-1a1c35d9f48555eb1f18d616787e4531.ttf";